import styles from './MobileBgWhiteBlur.module.scss'


const MobileBgWhiteBlur: React.FC = () => {
    return (
    <div className={styles.container}></div>
    )
}
export default MobileBgWhiteBlur